import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
  useAddCertificateMutation,
  useDeleteCertificateMutation,
  useEditCertificateMutation
} from "../../../../../redux/api/handBooksApi/organic/certificateApi";
import { EntBasicHB } from "../../../../../models/handBooks/basicHB";

const useCertificate = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addCertificate] = useAddCertificateMutation();
  const [deleteCertificate] = useDeleteCertificateMutation();
  const [editCertificate] = useEditCertificateMutation();

  async function onAddCertificate(newCertificate: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addCertificate(newCertificate).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteCertificate(certificate: EntBasicHB) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteCertificate(certificate.id).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };

  async function onEditCertificate(editedCertificate: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editCertificate(editedCertificate).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };
  return { onAddCertificate, onDeleteCertificate, onEditCertificate }

}
export { useCertificate };

